"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState, useEffect } from "react";
import { cn } from "@/lib/utils";
export default function SplitText(t0) {
  const $ = _c(15);
  const {
    text: t1,
    className
  } = t0;
  const text = t1 === undefined ? "SAMY" : t1;
  const [activeIndex, setIndex] = useState();
  const timer = useRef(undefined);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== className) {
    t4 = cn("relative inline-block", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== text) {
    t5 = <span className="invisible leading-none block">{text}</span>;
    $[4] = text;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeIndex || $[7] !== text) {
    t6 = (/[\u0600-\u06FF]/.test(text) ? text.split(/(\s+)/) : text.split("")).map((letter, index) => {
      const distance = activeIndex !== undefined ? Math.abs(index - activeIndex) : null;
      const topTranslate = distance === 0 ? " -translate-y-5" : distance === 1 ? " -translate-y-3" : distance === 2 ? " -translate-y-1" : "";
      const bottomTranslate = distance === 0 ? " translate-y-5" : distance === 1 ? " translate-y-3" : distance === 2 ? " translate-y-1" : "";
      return <span onMouseEnter={() => {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        setIndex(index);
      }} onMouseLeave={() => {
        timer.current = setTimeout(() => {
          setIndex(undefined);
        });
      }} key={`${letter}-${index}`} className="relative inline-flex h-full flex-col leading-none" aria-hidden={true}><span className={`${"block h-1/2 select-none leading-none transition-transform duration-300 ease-out whitespace-pre"}${topTranslate}`} style={{
          clipPath: "inset(-100% -100% -0.5px -100%)"
        }}>{letter}</span><span className={`${"block h-1/2 select-none leading-none transition-transform duration-300 ease-out whitespace-pre"}${bottomTranslate}`} style={{
          clipPath: "inset(-0.5px -100% -100% -100%)"
        }}><span className="absolute -translate-y-1/2 leading-none">{letter}</span></span></span>;
    });
    $[6] = activeIndex;
    $[7] = text;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <span className="absolute top-0 flex h-full">{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <span className={t4}>{t5}{t7}</span>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}